import styled from 'styled-components';
import { Box } from "../../../box/src";
export const Cell = styled(Box).attrs(() => ({
    display: 'table-cell',
    px: '6px',
    py: 4,
})) `
  border-bottom: 1px solid ${({ theme }) => theme.colors.horizon};
  vertical-align: ${({ $verticalAlign }) => $verticalAlign};
`;
//# sourceMappingURL=Cell.js.map